export default __webpack_public_path__ + "static/media/pj_cover.7f407ce1.png";